export const  mobile = (width, height = 0) => {
    if ((window.innerWidth > width && window.innerHeight > height)) {
        return false
    }
    return true
}